<template>
  <div>
    <h1>PIM Collections</h1>
      <div class="pb-4">
    <button class="appButton mt-2" @click="this.$router.push('/pim')">{{ $t('menu.pim.subpages.products.back')
      }}</button>
  </div>
  </div>
</template>
